import React, { useEffect, useState } from 'react'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useParams } from 'react-router-dom';
import { ContentWrapper, Markdown } from '../../../components/containers'
import { BackgroundPageTitle, VideoPlayer } from '../../../components/molecules';
import { SingleStudySidebar } from '../../../components/organisms';
import { useStudiesHook } from '../../../hooks/Study/StudiesHook';
import { IStudy } from '../../../types/study.type';
import { withLayout } from '../../../hocs/withLayout';
import { withAuth } from '../../../hocs';
import { Skeleton } from '@/components/ui/skeleton';

export const SingleStudy = () => {
    const params = useParams();
    const { currentStudy, getSingleStudy, status, clearSingleStudySearch } = useStudiesHook();
    const navigate = useNavigate();
    const [showIntro, setShowIntro] = useState(true);
    const [backgroundSubtitle, setBackgroundSubtitle] = useState('');

    useEffect(() => {
        if (status === 'fetching' || status === 'fetched') {
            return;
        }

        getSingleStudy(params.slug as string)
            .then((study: IStudy) => {
                setBackgroundSubtitle(`${study.pasGroupCategory?.name}, ${study.cycle?.title}`);
            });
        return () => {
            clearSingleStudySearch();
        }
    }, [params]);


    if (!currentStudy) {
        return <div className="min-h-full">
            <Skeleton className="rounded-none h-56 md:h-56 lg:h-56 -mt-20" />
            <ContentWrapper className="flex pt-2 text-opacity-25 flex-col md:flex-row mt-6 pb-6 space-x-0 md:space-x-3 space-y-4 md:space-y-0">
                <Skeleton className="flex-grow h-120 rounded-md border-1 dark:border-gray-700" />
                <Skeleton className="h-100 w-full md:w-64 lg:w-64 xl:w-64 rounded-md border-1 dark:border-gray-700" />
            </ContentWrapper>
        </div>
    }

    return (
        <>
            <div className="min-h-full">
                <BackgroundPageTitle imageURL={currentStudy.imageURL} title={currentStudy.title} subtitle={backgroundSubtitle} heigthSize="sm" />
                <ContentWrapper className="flex pt-2 text-opacity-25 flex-col md:flex-row mt-6 pb-6 space-x-0 md:space-x-3 space-y-4 md:space-y-0">
                    <div className="flex-grow flex flex-col md:overflow-y-scroll space-y-3 no-scrollbar">
                        {
                            currentStudy.introContent && showIntro &&
                            <div className="bg-gpas-100 dark:bg-gray-800 text-gpas-700 text-black dark:text-white px-6 py-4 rounded-md border-1 dark:border-gray-700">
                                <Markdown content={currentStudy.introContent} />
                                <button onClick={e => {
                                    e.preventDefault();
                                    setShowIntro(false);
                                }} className="bg-gpas-700 dark:bg-gpas-700 text-white dark:text-gray-100 px-3 py-2 flex items-center flex-row space-x-2 mt-4 rounded-md hover:bg-gpas-900">
                                    <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                                    Entendido
                                </button>
                            </div>
                        }
                        <div className="bg-gray-50 bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-md px-6 py-4 text-black dark:text-white">
                            {
                                currentStudy.externalVideoURL &&
                                <div className="pb-4">
                                    <VideoPlayer videoURL={currentStudy.externalVideoURL} />
                                </div>
                            }

                            <Markdown content={currentStudy.content} />
                        </div>
                    </div>
                    <div className="flex-initial md:sticky">
                        <SingleStudySidebar
                            goBackAction={() => navigate(-1)}
                            onHideAction={() => {

                            }}
                            title="Información"
                            subtitle={currentStudy.subtitle}
                            startAt={currentStudy.startAt}
                            endAt={currentStudy.endAt}
                            pasGroupCategory={currentStudy.pasGroupCategory}
                            cycle={currentStudy.cycle}
                            files={currentStudy.files} />
                    </div>
                </ContentWrapper>
            </div>
        </>
    )
}

export const SingleStudyPage = withLayout(withAuth(SingleStudy))